import axios from 'axios';
import Trimaster from "@/plugins/servers/trimaster.js";
import moment from "moment";
import vuetifyToast from "@/vuetifyToast.js";
const env = process.env;

const request = function (packet) {
    return axios(packet)
        .then(response => {
            return [response.data];
        })
        .catch(err => {
            if (err && err.response && err.response.data && err.response.data.error && err.response.data.error.message) {
                return [null, err.response.data.error.message]
            }
            return [null, err]
        })
}

// This is just a more complicated version of JSON.stringify()
function getDataFromObject(data) {
    let urlAdditions = ''

    if (Object.keys(data).length) {
        Object.keys(data).forEach(key => {

            if (typeof data[key] == 'object') {
                urlAdditions += `&${key}=${encodeURIComponent(JSON.stringify(data[key]))}`
            } else if (Array.isArray(data)) {
                // TODO: Not sure if this is how it consumes the data...
                urlAdditions += `&${key}=[${encodeURIComponent(data[key].toString())}]`
            } else {
                urlAdditions += `&${key}=${encodeURIComponent(data[key])}`
            }

        })
    }

    return urlAdditions
}

function getAuthorizationToken(key) {
    let userInfo = JSON.parse(window.localStorage.getItem('user'));
    return `${userInfo.apitoken}|${userInfo.id}|${userInfo.facility.state}|${key}|${userInfo.facility_id}`;
}

export default class Metrc {
    constructor(vm = {}) {
        Object.assign(this, vm)
    }


    static validateApiKey(key, callback) {
        this.get("Facilities/get", {}, key).then(function ([res, err]) {

            let facilityNames = new Set();
            if (res) {
                facilityNames = res.data.map((a) => a.DisplayName);
                facilityNames = new Set(facilityNames);
            }
            callback(facilityNames.size > 0, facilityNames);
        });
    }

    static getPlantBatchTypes() {
        return [
            "Seed",
            "Clone"
        ];
    }

    static get(uri, data = {}, userApiKey) {

        if (uri[0] === '/') {
            uri = uri.substr(1)
        }
        let authToken = getAuthorizationToken(userApiKey);

        const packet = {
            data,
            method: 'GET',
            url: `${env.VUE_APP_metrc}/api/v1/${uri}`,
            headers: {
                Accept: 'application/json',
                Authorization: authToken
            }
        }

        let params = getDataFromObject(data);

        if (params.length) {
            packet.url += '?' + params.substring(1);
        }

        return request(packet)
    }


    static delete(uri, data = {}) {

        if (uri[0] === '/') {
            uri = uri.substr(1)
        }

        const packet = {
            data,
            method: 'DELETE',
            url: `${env.VUE_APP_metrc}/api/v1/${uri}`,
            headers: {
                Accept: 'application/json',
                Authorization: getAuthorizationToken()
            }
        }

        let params = getDataFromObject(data);

        if (params.length) {
            packet.url += '?' + params.substring(1);
        }

        return request(packet);
    }

    static post(uri, data = {}, headers = {}, params = {}) {

        headers['Accept'] = 'application/json'
        headers['Content-Type'] = 'application/json'

        if (uri[0] === '/') {
            uri = uri.substr(1)
        }

        let fullUri = `${env.VUE_APP_metrc}/api/v1/${uri}`


        fullUri += `${getDataFromObject(params)}`


        const packet = {
            data,
            method: 'POST',
            url: fullUri,
            headers: {
                Accept: 'application/json',
                Authorization: getAuthorizationToken()
            }
        }

        return request(packet)
    }

    static patch(uri, data = {}, headers = {}, params = {}) {

        headers['Accept'] = 'application/json'
        headers['Content-Type'] = 'application/json'


        if (uri[0] === '/') {
            uri = uri.substr(1)
        }

        let fullUri = `${env.VUE_APP_metrc}/api/v1/${uri}`
        fullUri += `${getDataFromObject(params)}`

        const packet = {
            data,
            method: 'PATCH',
            url: fullUri,
            headers: {
                Accept: 'application/json',
                Authorization: getAuthorizationToken()
            }
        }

        return request(packet)
    }

    //
    // synchronization routines
    //

    static patchStrain(user, strainRec) {
        let me = this;

        if (user.facility.isMetrcEnabled) {
            let LicenseNumber = window.localStorage.getItem('metrcLicense');
            let payload = {
                Name: strainRec.strainName,
                TestingStatus: strainRec.testingStatus,
                ThcLevel: strainRec.thcLevel,
                CbdLevel: strainRec.cbdLevel,
                IndicaPercentage: strainRec.indicaPercentage,
                SativaPercentage: strainRec.sativaPercentage
            }
            this.get('Strains', {
                filter: {
                    where: {
                        LicenseNumber: LicenseNumber,
                        Name: strainRec.strainName
                    }
                }
            }).then(function ([res, err]) {
                let metrcUrl = "";
                if (res.length == 1) {
                    payload.Id = res[0].Id;
                    metrcUrl = "strains/v1/update";
                } else {
                    metrcUrl = "strains/v1/create";
                }
                return me.post('Outboxes', {
                    LicenseNumber: LicenseNumber,
                    userMetrcApiKey: localStorage.getItem('metrcApiKey') || user.facility.metrcApiKey,
                    userId: user.id,
                    action: "POST",
                    service: metrcUrl,
                    payload: JSON.stringify([payload])
                });
            }).then(function ([res, err]) {
                if (err) {
                    alert("Metrc integration failed.");
                }
            })
        }
    }

    static deleteStrain(user, strainRec) {
        let me = this;

        if (user.facility.isMetrcEnabled) {
            let LicenseNumber = window.localStorage.getItem('metrcLicense');
            this.get('Strains', {
                filter: {
                    where: {
                        LicenseNumber: LicenseNumber,
                        Name: strainRec.strainName
                    }
                }
            }).then(function ([res, err]) {
                if (res.length == 1) {
                    res = res[0];
                    me.post('Outboxes', {
                        LicenseNumber: LicenseNumber,
                        userMetrcApiKey: localStorage.getItem('metrcApiKey') || user.facility.metrcApiKey,
                        userId: user.id,
                        action: "DELETE",
                        service: "strains/v1/" + res.Id
                    });
                }
            })
        }
    }

    // keys :
    // config.lifecycle_id
    // config.Count
    // config.ReasonNote

    static plantBatchDestroyPlants(user, config) {

        let me = this;
        Trimaster.get('ag_lifecycles/' + config.lifecycle_id, user.apitoken).then(function ([res, err]) {

            me.post('Outboxes', {
                LicenseNumber: window.localStorage.getItem('metrcLicense'),
                userMetrcApiKey: localStorage.getItem('metrcApiKey') || user.facility.metrcApiKey,
                userId: user.id,
                action: "POST",
                service: "plantbatches/v1/destroy",
                payload: JSON.stringify([{
                    PlantBatch: res.metrcPlantBatchName,
                    Count: config.Count,
                    ReasonNote: config.ReasonNote,
                    ActualDate: moment().format('YYYY-MM-DD')
                }])
            })
        })

    }

    // keys :
    // config.lifecycle_id
    // config.Count
    // config.ReasonNote

    static plantBatchSplit(user, config) {
        let me = this;
        Trimaster.get(
            'ag_lifecycles/' + config.lifecycle_id,
            user.apitoken)
            .then(function ([res, err]) {
                // hey
            })
    }

    // keys :
    // config.lifecycle_id
    // config.metrcStartingTag
    // config.metrcTagPrefix
    // config.plantIds

    static transplant(user, config) {
        let me = this;
        Trimaster.post('ag_plants/metrcTransplant', user.apitoken, {
            lifecycle_id: parseInt(config.lifecycle_id),
            metrcStartingTag: config.metrcStartingTag,
            metrcTagPrefix: config.metrcTagPrefix,
            plantIds: config.plantIds
        }).then(function ([res, err]) {
            let promises = [];
            for (let i in res.plantLocations) {
                let growthPhase = res.plantLocations[i][0].growthPhase;
                let startingTag = res.plantLocations[i][0].tag;
                promises.push(
                    me.post('Outboxes', {
                        LicenseNumber: window.localStorage.getItem('metrcLicense'),
                        userMetrcApiKey: localStorage.getItem('metrcApiKey') || user.facility.metrcApiKey,
                        userId: user.id,
                        action: "POST",
                        service: "plantbatches/v1/changegrowthphase",
                        payload: JSON.stringify([{
                            Name: res.plantBatchName,
                            Count: res.plantLocations[i].length,
                            StartingTag: startingTag,
                            GrowthPhase: growthPhase,
                            newLocation: i,
                            GrowthDate: moment().format('YYYY-MM-DD')
                        }])
                    })
                )
            }

            return Promise.all(promises);

        }).then(function () {
            vuetifyToast.success("Function Complete");
        }).catch(function (e) {
            vuetifyToast.error("An error occurred. Please try again later.");
            console.log(e);
        })

    }

    static transitionFromVeg(user, config) {
        let me = this;
        Trimaster.get('ag_plantLocations', user.apitoken, {
            filter: {
                where: {
                    lifecycle_id: config.lifecycle_id,
                    plant_id: { inq: config.plantIds },
                },
                include: [
                    {
                        relation: "ag_plants",
                        scope: {
                            include: [
                                {
                                    relation: "lifecycle",
                                    scope: {
                                        fields: ["metrcPlantBatchName"]
                                    }
                                },
                                {
                                    relation: "lifecyclePhase",
                                    scope: {
                                        include: [
                                            {
                                                relation: "ag_growPhases",
                                                scope: {
                                                    include: ["ag_growStage"]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }).then(function ([plantLocations, err]) {
            let promises = [];
            plantLocations.forEach(plantLocation => {
                let growthPhase = plantLocation.ag_plants.lifecyclePhase.ag_growPhases.ag_growStage.label;
                let tag = plantLocation.ag_plants.tag;
                let location = plantLocation.platformGroupName;
                promises.push(
                    me.post('Outboxes', {
                        LicenseNumber: window.localStorage.getItem('metrcLicense'),
                        userMetrcApiKey: localStorage.getItem('metrcApiKey') || user.facility.metrcApiKey,
                        userId: user.id,
                        action: "POST",
                        service: "plants/v1/changegrowthphases",
                        payload: JSON.stringify([
                            {
                                Id: null,
                                Label: tag,
                                NewTag: tag,
                                GrowthPhase: growthPhase,
                                NewLocation: location,
                                GrowthDate: moment().format('YYYY-MM-DD')
                            }
                        ])
                    })
                )
            })

            return Promise.all(promises);

        }).then(function () {
            vuetifyToast.success("Function Complete");
        }).catch(function (e) {
            vuetifyToast.error("An error occurred. Please try again later.");
            console.log(e);
        })

    }

    static destroyPlants(user, plants) {

        if (user.facility.isMetrcEnabled) {
            let payload = [];

            for (let i = 0; i < plants.length; i++) {
                if (plants[i].tag) {
                    payload.push({
                        Label: plants[i].tag,
                        WasteReasonName: plants[i].DestroyPlantReasonMetrc,
                        ReasonNote: plants[i].description,
                        ActualDate: moment().format('YYYY-MM-DD'),
                        WasteMethodName: plants[i].selectedMetrcMethod,
                        WasteMaterialMixed: plants[i].metrcWasteMaterial,
                        WasteWeight: plants[i].metrcWasteWeight*1,
                        WasteUnitOfMeasureName: "grams",
                    })
                }
            }
            if (payload.length > 0) {
                this.post('Outboxes', {
                    LicenseNumber: window.localStorage.getItem('metrcLicense'),
                    userMetrcApiKey: localStorage.getItem('metrcApiKey') || user.facility.metrcApiKey,
                    userId: user.id,
                    action: "POST",
                    service: "plants/v1/destroyplants",
                    payload: JSON.stringify(payload)
                }).then(function () {
                    // no op
                }).catch(function (e) {
                    vuetifyToast.error("An error occurred. Please try again later.");
                    console.log(e);
                });
            }
        }

    }

    static movePlants(user, lifecycle_id, plantIds) {
        let me = this;
        if (user.facility.isMetrcEnabled) {
            Trimaster.get('ag_lifecycles/getPlantPositions', user.apitoken, {
                lifecycle_id: lifecycle_id,
                plantIds: plantIds
            }).then(function ([res, err]) {
                if (res.success) {
                    let payload = [];
                    for (let i = 0; i < res.data.length; i++) {
                        payload.push({
                            Label: res.data[i].tag,
                            Location: res.data[i].platformGroupName,
                            ActualDate: moment().format('YYYY-MM-DD')
                        })
                    }
                    me.post('Outboxes', {
                        LicenseNumber: window.localStorage.getItem('metrcLicense'),
                        userMetrcApiKey: localStorage.getItem('metrcApiKey') || user.facility.metrcApiKey,
                        userId: user.id,
                        action: "POST",
                        service: "plants/v1/moveplants",
                        payload: JSON.stringify(payload)
                    }).then(function () {
                        // no op
                    }).catch(function (e) {
                        vuetifyToast.error("An error occurred. Please try again later.");
                        console.log(e);
                    });

                } else {
                    vuetifyToast.error("An error occurred. Please try again later.");
                }
            })
        }
    }

    static harvest(user, lifecycle_id) {
        let me = this;

        if (user.facility.isMetrcEnabled) {

            Trimaster.get('ag_plants', user.apitoken, {
                filter: {
                    limit: 250,
                    include: 'batch',
                    where: {
                        lifecycle_id: lifecycle_id
                    }
                }
            }).then(function ([res, err]) {
                let plants = res;
                let harvestPayload = [];
                for (let i = 0; i < plants.length; i++) {
                    if (!plants[i].destroyPlantReason_id) {
                        harvestPayload.push({
                            Plant: plants[i].tag,
                            Weight: plants[i].wetWeight,
                            UnitOfWeight: "Grams",
                            DryingLocation: "Dry Room " + plants[i].dryingRooms,
                            HarvestName: plants[i].batch.label,
                            ActualDate: moment(plants[i].harvestDate).format('YYYY-MM-DD')
                        })
                    }
                }

                return me.post('Outboxes', {
                    LicenseNumber: window.localStorage.getItem('metrcLicense'),
                    userMetrcApiKey: localStorage.getItem('metrcApiKey') || user.facility.metrcApiKey,
                    userId: user.id,
                    action: "POST",
                    service: "plants/v1/harvestplants",
                    payload: JSON.stringify(harvestPayload)
                })
            }).then(function () {
                // no op
            }).catch(function (e) {
                vuetifyToast.error("An error occurred. Please try again later.");
                console.log(e);
            });

        }
    }

    // data keys:
    // batch_id (number)
    // wasteWeight (number)
    // harvestName

    static finishHarvest(user, data) {
        let me = this;
        return new Promise((resolve, reject) => {
            let metrcHarvestId = null;

            Metrc.get('Harvests', {
                filter: {
                    where: {
                        Name: data.harvestName
                    }
                }
            }).then(function ([res, err]) {
                if (res && res.length == 1) {
                    metrcHarvestId = res[0].Id;
                    let harvestPayload = {
                        Id: res[0].metrcHarvestId,
                        WasteType: "Plant Material",
                        UnitOfWeight: "Grams",
                        WasteWeight: data.weight,
                        ActualDate: moment().format('YYYY-MM-DD')
                    }
                    return me.post('Outboxes', {
                        LicenseNumber: window.localStorage.getItem('metrcLicense'),
                        userMetrcApiKey: localStorage.getItem('metrcApiKey') || user.facility.metrcApiKey,
                        userId: user.id,
                        action: "POST",
                        service: "plants/v1/removewaste",
                        payload: JSON.stringify(harvestPayload)
                    })
                } else {
                    reject("Harvest " + data.harvestName + ' is not present in Metrc');
                }
            }).then(function ([res, err]) {
                return Trimaster.patch('ag_batches', this.getUser.apitoken, {
                    id: data.batch_id,
                    isHarvestFinished: true
                })
            }).then(function ([res, err]) {
                let harvestPayload = {
                    Id: metrcHarvestId,
                    ActualDate: moment().format('YYYY-MM-DD')
                }
                return me.post('Outboxes', {
                    LicenseNumber: window.localStorage.getItem('metrcLicense'),
                    userMetrcApiKey: localStorage.getItem('metrcApiKey') || user.facility.metrcApiKey,
                    userId: user.id,
                    action: "POST",
                    service: "harvests/v1/finish",
                    payload: JSON.stringify(harvestPayload)
                })
            }).then(function ([res, err]) {
                if (res) {
                    resolve({ success: true });
                }
            })
        })


    }

    static createPlantingsFromMothers(user, cuttings, metrcBatchLabel, destination) {
        if (user.facility.isMetrcEnabled) {
            let payload = [];
            let plantLabel = cuttings.length ? cuttings[0].tag : null;
            let strain = cuttings.length ? cuttings[0].strain : null;
            let totalPlants = cuttings.reduce((total, current) => {
              return total + current.cuttings;
            }, 0)

            if (cuttings[0].clonesTag && cuttings[0].clonesTag !== '') {
              // In Nevada, cuttings from different mothers have their own tag (PlantBatchName)
              payload = cuttings.map(cutting => {
                return {
                  PlantLabel: plantLabel,
                  PlantBatchName: cutting.clonesTag,
                  PlantCount : cutting.cuttings,
                  PlantBatchType: "Clone",
                  LocationName: destination,
                  StrainName: cutting.strain,
                  ActualDate: moment.utc().format()
                }
              })
            } else {
              payload.push({
                PlantLabel: plantLabel,
                PlantBatchName: metrcBatchLabel,
                PlantCount : totalPlants,
                PlantBatchType: "Clone",
                LocationName: destination,
                StrainName: strain,
                ActualDate: moment.utc().format()
              });
            }

            return this.post('Outboxes', {
                LicenseNumber: window.localStorage.getItem('metrcLicense'),
                userMetrcApiKey: window.localStorage.getItem('metrcApiKey') || user.facility.metrcApiKey,
                userId: user.id,
                action: "POST",
                service: "plants/v1/create/plantings",
                payload: JSON.stringify(payload)
            });

        }
    }


    static createPlantings(user,{name,type,count,strain,location,date}) {
        let me = this;

        if (user.facility.isMetrcEnabled) {

            let payload = {
                Name: name,
                Type: type,
                Count: count,
                Strain: strain,
                Location: location,
                ActualDate: moment(date).format('YYYY-MM-DD')
            };

            return me.post('Outboxes', {
                LicenseNumber: window.localStorage.getItem('metrcLicense'),
                userMetrcApiKey: window.localStorage.getItem('metrcApiKey') || user.facility.metrcApiKey,
                userId: user.id,
                action: "POST",
                service: "plantbatches/v1/createplantings",
                payload: JSON.stringify(payload)
            })

        }
    }

    static createTestBatch(user, data) {
        let me = this;

        if (user.facility.isMetrcEnabled) {

            Trimaster.get('ag_batches/' + data.fromBatchNumber, user.apitoken).then(function ([batchInfo, err]) {
                let payload = [{
                    Tag: data.metrcTag,
                    UnitOfWeight: "Grams",
                    Ingredients: [
                        {

                            "HarvestName": batchInfo.label,
                            "Weight": data.sampleSize,
                            "UnitOfWeight": "Grams"
                        }
                    ]
                }];
                return me.post('Outboxes', {
                    LicenseNumber: window.localStorage.getItem('metrcLicense'),
                    userMetrcApiKey: localStorage.getItem('metrcApiKey') || user.facility.metrcApiKey,
                    userId: user.id,
                    action: "POST",
                    service: "harvests/v1/create/packages/testing",
                    payload: JSON.stringify(payload)
                })
            })

        }
    }
}
